import { useEffect } from 'react';
import DataTable from '../../components/common/DataTable';
import ExportComponent from '../../components/common/ExportComponent';
import FilterDateComponent from '../../components/common/FilterDateComponent';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
  view_all_table,
} from '../../shared/enums/clients_enum';
import {
  useAllClients,
  useGetDropdownOptions,
} from '../../shared/hooks/UseClient';
import { UseDataForExcel, UseFilter } from '../../shared/hooks/UseExcel';
import TableSection from '../../utils/table-section';

const AllClients = ({}) => {
  const [data, setPageNumber, deleteBtnClicked] = useAllClients();
  const { clients_loading, clients, total_clients, page, pages } = data;

  // Related DropDown Started
  const [dropdownOptions, setClientSearchField, setClientSearchValue] =
    useGetDropdownOptions();
  const loadOptions = async (inputValue, callback, field) => {
    if (field == 'client') {
      await setClientSearchField('name');
      await setClientSearchValue(inputValue);
      callback(dropdownOptions.client);
    }
  };

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (clients) {
      convertToReadable(clients, inputFields);
    }
  }, [clients]);

  const handleOnExport = () => {
    exportXLSXData(exportData, 'Clients', 'clients');
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />
        <ExportComponent handleOnExport={handleOnExport} />
        <FilterDateComponent link='/clients' />

        <TableSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_data={total_clients}
          data={clients}
          data_loading={clients_loading}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          deleteBtnClicked={deleteBtnClicked}
          view_all_table={view_all_table}
          inputFields={inputFields}
          PAGE_TITLE={PAGE_TITLE}
          PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
          LINK_URL={LINK_URL}
          DataTable={DataTable}
          TABLE_TITLE='Clients Management'
        />
        {/* <EnhancedClientsSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_clients={total_clients}
          clients={clients}
          clients_loading={clients_loading}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          deleteBtnClicked={deleteBtnClicked}
          view_all_table={view_all_table}
          inputFields={inputFields}
          PAGE_TITLE={PAGE_TITLE}
          PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
          LINK_URL={LINK_URL}
          DataTable={DataTable}
          Pagination={Pagination}
          AddBtn={AddBtn}
        /> */}
      </div>
    </div>
  );
};

export default AllClients;
